// MEGA MENU
function mmMegaMenuShowProducts(classElemsToHide, classElemToShow) {
  var imageContainers = document.querySelectorAll(classElemsToHide);
  imageContainers.forEach(function(imageContainer){
    imageContainer.style.display = 'none';
  })
  document.querySelector(classElemToShow).style.display = 'grid';
}

function getMegaMenuPosition(){
  var menuElems = document.querySelectorAll('.mm-header-link');
  var header = document.querySelector('.mm-header');
  var headerHeight = header.offsetHeight;

  menuElems.forEach(function(menuElem) {
      if (menuElem.nextElementSibling) {
          if (menuElem.nextElementSibling.classList.contains('mm-mega-menu-wrapper')) {
            menuElem.nextElementSibling.style.top = `calc(${headerHeight}px)`;
          }
      }
  })
}

document.addEventListener("DOMContentLoaded", (event) => {
  getMegaMenuPosition();
});

// MOBILE MENU
function mmMobileMenu() {
    const header = document.querySelector("header");
    const icon = document.querySelector(".mm-header-burger");
    const mobileMenu = document.querySelector(".mm-mobile-menu-wrapper");
    document.querySelector("html").classList.toggle("stop-scrolling");
    document.querySelector("body").classList.toggle("stop-scrolling");

    header.classList.toggle("mm-open");
    icon.classList.toggle("mm-open");
    mobileMenu.classList.toggle("mm-menu-open");
    console.log('height :', document.getElementById('get_header_vertical_position').getBoundingClientRect().top);
    mobileMenu.style.top = document.getElementById('get_header_vertical_position').getBoundingClientRect().top + "px";
}

class ProductRecommendations extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);

            fetch(this.dataset.url)
                .then((response) => response.text())
                .then((text) => {
                    const html = document.createElement("div");
                    html.innerHTML = text;
                    const recommendations = html.querySelector("product-recommendations");

                    if (recommendations && recommendations.innerHTML.trim().length) {
                        this.innerHTML = recommendations.innerHTML;
                    }

                })
                .catch((e) => {
                    console.error(e);
                });
        };

        new IntersectionObserver(handleIntersection.bind(this), { rootMargin: "0px 0px 400px 0px" }).observe(this);
    }
}

customElements.define("product-recommendations", ProductRecommendations);
function animatedDropdowns(){
  const faqColl = document.querySelectorAll('.mm-faq-collapsible');
  let q;

  for (q = 0; q < faqColl.length; q++) {
      faqColl[q].addEventListener('click', function () {
          this.classList.toggle('active');

          const content = this.nextElementSibling;

          if (content.style.maxHeight) {
              content.style.maxHeight = null;
          } else {
              content.style.maxHeight = content.scrollHeight + 'px';
          }
      });
  }
}

window.addEventListener("DOMContentLoaded", (event) => {
  animatedDropdowns();
});

/* mobile drawer height */
const documentHeight = () => {
  const doc = document.documentElement
  doc.style.setProperty('--doc-height', `${window.innerHeight}px`)
}
window.addEventListener('resize', documentHeight)
documentHeight()